import React, { useState } from "react"
import LogoImg from "../assets/images/tlogo.png"
import { LinkData } from "../assets/data/dummydata"
import { NavLink } from "react-router-dom"
import { HiOutlineMenuAlt1, HiViewGrid } from "react-icons/hi"
import { useNavigate } from 'react-router-dom';

export const Header = () => {
  const navigate = useNavigate();
  const handleClick = () => {
    navigate('/onboard'); // Navigate to the /onboard page
  };
  const [open, setOpen] = useState(false)
  return (
    <>
      <header className='bg-primary py-2 text-black sticky z-50 shadow-md top-0 left-0 w-full'>
        <div className='container flex justify-between items-center'>
          <div className='logo flex items-center gap-6'>
            <img src={LogoImg} alt='logo' className='lg:h-20  md:h-14 sm:h-12' />
          </div>
          <nav className={open ? "mobile-view" : "desktop-view"}>
            <ul className='flex items-center gap-6'>
              {LinkData.map((link) => (
                <li key={link.id} onClick={() => setOpen(null)}>
                  <NavLink className={({ isActive }) => (isActive ? "text-white text-lg " : "text-lg")} to={link.url}>
                    {link.title}
                  </NavLink>
                </li>
              ))}
            </ul>
          </nav>
          <div className='account flex items-center gap-5'>
            <button className='px-5 py-2 border border-gray-300 rounded-md text-sm' onClick={handleClick}>Join us</button>
            <button className='open-menu' onClick={() => setOpen(!open)}>
              <HiOutlineMenuAlt1 size={25} />
            </button>
          </div>
        </div>
      </header>
    </>
  )
}
